function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MalawiFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_2366",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_2366)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#E11C1B"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_2366",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_2366)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V10.5H24V3H0Z",
        fill: "#272727"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 15V21H24V15H0Z",
        fill: "#5EAA22"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.00122 13.4594V13.4576L2.9942 13.4588L3.00122 13.4594ZM3.47259 10.5951H3.54988L3.43141 10.577L3.47259 10.5951ZM5.6682 10.5951C5.70747 10.5197 5.74847 10.445 5.79116 10.3712L4.07406 9.23454L6.09936 9.89337C6.21263 9.73498 6.33407 9.58142 6.46318 9.43311L4.97486 8.01611L6.8715 9.00584C7.01063 8.87299 7.15646 8.74547 7.30852 8.62367L6.10484 6.96087L7.80476 8.26131C7.96289 8.15619 8.12634 8.05675 8.29469 7.96332L7.42769 6.10274L8.86369 7.67904C9.03483 7.60253 9.21006 7.53189 9.38903 7.46745L8.9009 5.46929L10.0128 7.27228C10.1918 7.22444 10.3739 7.1826 10.5587 7.14702L10.4771 5.0809L11.2167 7.04848C11.3993 7.02879 11.5841 7.01514 11.7708 7.00776L12.1057 4.95003L12.4406 7.00836C12.6271 7.01607 12.8117 7.03003 12.994 7.05002L13.7342 5.0809L13.6526 7.14986C13.8367 7.18567 14.0181 7.2277 14.1964 7.27568L15.3104 5.46929L14.8211 7.47236C14.999 7.5368 15.1732 7.60737 15.3434 7.68375L16.7836 6.10274L15.9136 7.96985C16.0806 8.06294 16.2428 8.16196 16.3997 8.26657L18.1065 6.96087L16.8974 8.63118C17.048 8.75223 17.1924 8.87891 17.3303 9.01083L19.2365 8.01611L17.7401 9.44082C17.8677 9.58795 17.9879 9.74025 18.1 9.89728L20.1373 9.23454L18.4095 10.3783C18.4507 10.4498 18.4903 10.5221 18.5283 10.5951H17.0547C16.0391 9.18737 14.1829 8.24488 12.0613 8.24488C9.93978 8.24488 8.08357 9.18737 7.06801 10.5951H5.6682ZM7.91973 10.5951C8.8819 9.60275 10.3927 8.96333 12.0915 8.96333C13.7903 8.96333 15.3011 9.60275 16.2633 10.5951H7.91973ZM20.6615 10.5951H20.7388L20.7799 10.577L20.6615 10.5951ZM21.2112 13.4578L21.2171 13.4588L21.2112 13.4593V13.4578Z",
        fill: "#E11C1B"
      })]
    })]
  })]
}));
//# sourceMappingURL=Malawi.js.map